// ThemeContext.js
import React, { createContext, useContext, useState, useEffect } from 'react'
import { themes } from '../themes'
import useAuth from '../hooks/useAuth'

const ThemeContext = createContext()

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(themes.default)
  const { mainDpt, setMainDpt } = useAuth()

  useEffect(() => {
    getTheme()
  }, [mainDpt])

  useEffect(() => {
    getTheme()
  }, [])

  const getTheme = () => {
    const { hostname } = window.location
    let link = document.querySelector("link[rel~='icon']")
    if (!link) {
      link = document.createElement('link')
      link.rel = 'icon'
      document.getElementsByTagName('head')[0].appendChild(link)
    }
    let selectedTheme = themes.default
    if (
      // hostname.includes('localhost') ||
      mainDpt === 'SAS' ||
      mainDpt === 'AIS' ||
      mainDpt === 'NAHT'
    ) {
      selectedTheme = themes.default
      document.title = 'Schools Advisory Service - School Portal'
      link.href = '/sas_favicon.ico'
    } else if (
      hostname.endsWith('.schoolsmutual.co.uk') ||
      mainDpt === 'Mutual' ||
      mainDpt === 'GBS'
    ) {
      document.title = 'Schools Mutual - School Portal'
      selectedTheme = themes.schoolsMutual // Wildcard domain check
      link.href = '/mutual_favicon.ico'
    } else if (hostname.endsWith('.cc-itl.com') || mainDpt === 'CC') {
      document.title = 'Cover and Care - School Portal'
      selectedTheme = themes.coverAndCare // Wildcard domain check
      link.href = '/cc_favicon.ico'
    }
    else if (hostname.endsWith('.sovriskmanagement.co.uk') || mainDpt === 'SRM') {
      document.title = 'Sovereign Risk Management - School Portal'
      selectedTheme = themes.sovriskManagement // Wildcard domain check
      link.href = '/srm-favicon.ico'
    }

    setTheme(selectedTheme)
  }

  return <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
}

export const useTheme = () => useContext(ThemeContext)
